import {assert} from './utilities/ErrorHandling';
import {ChecklistType} from '../globals';
import {ChecklistOption} from "../interfaces/checklistItem";

export function makeChecklistItemData(type: ChecklistType): null | ChecklistOption[]
{
	switch (type) 
	{
		case ChecklistType.TEXT: 
		case ChecklistType.CHECKBOX: 
		case ChecklistType.NUMBER: 
		case ChecklistType.PHOTO: 
		case ChecklistType.BARCODE: 
			return null;
		case ChecklistType.MULTI_OPTION: 
		case ChecklistType.MULTI_OPTION_SELECT: 
		case ChecklistType.MULTI_OPTION_3D: 
		case ChecklistType.MULTI_OPTION_SELECT_3D: 
			return makeMultiOptionTypeData();
		default:
			assert(false, "Unsupported checklist type: " + type);
			return null; // Explicit return to satisfy TypeScript's type checking
	}
}

export function makeMultiOptionTypeData(): ChecklistOption[]
{
	return [{ description: "Answer A", next: "", id: 0, correct: false },
		{ description: "Answer B", next: "", id: 1, correct: false }];
}
